/* global axios */
import WhatsAppSipApiClient from './index';

class WhatsAppSipCallPermissionsAPI extends WhatsAppSipApiClient {
  constructor() {
    super('call_permissions');
  }

  check(waId, inboxId) {
    return axios.post(`${this.url}/check`, { wa_id: waId, inbox_id: inboxId });
  }

  requestPermission(waId, message, inboxId) {
    return axios.post(`${this.url}/request`, {
      wa_id: waId,
      message,
      inbox_id: inboxId,
    });
  }
}

export default new WhatsAppSipCallPermissionsAPI();
